$(document).ready(() => {
  if ($('.steps').length > 0) $('.steps__video video').get(0).play();

  // Product Section
  $('.product-showcase__variant').on('click', function () {
    if ($(this).hasClass('bundle active')) {
      // $(this).removeClass('active');
      // $('.product-showcase__variant.size.active').click();
      return;
    }
    const selectedID = $(this).data('variant-id');

    $('.afterPay_pricing').hide();
    $('.afterPay_pricing').each(function(){
      if (selectedID == $(this).attr('data-id')){
        $(this).show();
      }
    });

    $('.product-showcase__price').text($(this).data("price"));
    $('.product-showcase__price-discounted').text($(this).data("compare"));
    $('.product-showcase__save').text('Save ' + $(this).data("off-price"));
    $('.product-showcase__save-percentage').text('-' + $(this).data("off-percentage") + '% OFF');

    $(this).siblings().removeClass('active');
    $(this).addClass('active');

    if ($(this).hasClass('size')) {
      const currSize = $(this).data('handleize');
      $('.product-showcase__variants-bundles').removeClass('active');
      $(`.product-showcase__variants-bundles[data-handleize="${currSize}"]`).addClass('active');
    }

    $('.Product_atc_form_id__js').val(selectedID);

    var location = String(window.location);
    if (location.indexOf('quiz-offer') != -1){
      if (selectedID == 46700506218844){
        $('.product-showcase__save-percentage').hide();
        $('.product-showcase__save').hide();
        $('.product-showcase__price-discounted').hide();
      }
      else{
        $('.product-showcase__save-percentage').show();
        $('.product-showcase__save').show();
        $('.product-showcase__price-discounted').show();
      }
    }
  });


 


  // Init Product Section
  // $('.product-showcase__variant.size.active').click();
  $('.product-showcase__variant.bundle.active').click();


  // Removing spaces between long-form-rich and long-form-featured
  var rich = $('.shopify-section > .long-form-featured').parent().prev().find('.long-form-rich');
  rich.css({ 'padding-bottom': '0' });
  rich.find('.long-form__title').css({ 'margin-bottom': '0' });


  // CTA Functionallity
  $('.ScrollToProduct').click(function () {
    var productElements = $('[id="product"]');
    if (productElements.length > 0) {
      var closestProductElement = productElements.first();
      var closestDistance = Math.abs($(window).scrollTop() - closestProductElement.offset().top);

      productElements.each(function () {
        var distance = Math.abs($(window).scrollTop() - $(this).offset().top);
        if (distance < closestDistance) {
          closestProductElement = $(this);
          closestDistance = distance;
        }
      });

      $('html, body').animate({
        scrollTop: closestProductElement.offset().top
      }, 400);
    }
  });

  // Details Section
  $('.details__selector').click(function () {
    if (!$(this).hasClass('active')) {
      var content = $(this).data('select');
      $(this).addClass('active').siblings().removeClass('active');
      $('.details-content').removeClass('active');
      $(`.details-content[data-content="${content}"]`).addClass('active');

      if ($('.details-content.active .carousel.slick-slider').length > 0) {
        $('.details-content.active .carousel').slick('slickGoTo', 0);
      }
    }
  });



  $('.whats-inside__select-title').click(function () {
    const selectedIndex = $(this).data('index');
    $('.whats-inside__select-title, .whats-inside__block').removeClass('active');
    $(this).addClass('active');
    $('.whats-inside__block[data-index="' + selectedIndex + '"]').addClass('active');
  });


  // Custom-Grid Percentage values
  if ($(".custom-grid__block-percentage").length > 0) {
    var observer = new IntersectionObserver(handleIntersection, {
      root: null,
      rootMargin: "0px",
      threshold: 0.5
    });

    $(".custom-grid__block-percentage").each(function () {
      observer.observe(this);
    });
  }


  // 2 Carousels with Navigation(Thumbnails)
  $(':not(.simplified)>.product-showcase__main-carousel').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: "<button type='button' class='slick-prev pull-left gg-chevron'>Prev</button>",
    nextArrow: "<button type='button' class='slick-next pull-right gg-chevron'></div>Next</button>",
    asNavFor: '.product-showcase__thumbnail-carousel'
  });
  $('.simplified>.product-showcase__main-carousel').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    centerMode: true,
    centerPadding: '26% 0 0',
    asNavFor: '.product-showcase__thumbnail-carousel',
    prevArrow: "<button type='button' class='slick-prev pull-left gg-chevron'>Prev</button>",
    nextArrow: "<button type='button' class='slick-next pull-right gg-chevron'></div>Next</button>",
  });
  $('.product-showcase__thumbnail-carousel').slick({
    infinite: true,
    arrows: false,
    dots: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: '.product-showcase__main-carousel',
  });

  // Add click event handler to thumbnail carousel items
  $('.product-showcase__thumbnail-carousel .slick-slide').on('click', function () {
    $('.product-showcase__main-carousel, .product-showcase__thumbnail-carousel').slick(
      'slickGoTo', $(this).data('slick-index')
    );
  });

  // Accordion (FAQ, Product__showcase)
  $(".accordion > .accordion-item.is-active").children(".accordion-panel").slideDown();
  $(".accordion > .accordion-item").click(function () {
    $(this).siblings(".accordion-item").removeClass("is-active").children(".accordion-panel").slideUp();
    $(this).toggleClass("is-active").children(".accordion-panel").slideToggle("ease-out");
  });


  // Slick For Mobile Config + Init
  const carouselConfigs = [
    {
      carousel: $('.ratings__container'),
      options: {
        infinite: false,
        arrows: false,
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      carousel: $('.details-content .carousel'),
      options: {
        infinite: true,
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: '26% 0 0'
      }
    }
  ];

  carouselConfigs.forEach(config => {
    if (config.carousel.length > 0) {
      handleSlick(config.carousel, config.options);
      $(window).resize(function () {
        handleSlick(config.carousel, config.options);
      });
    }
  });

  if ($('.long-form__title.timer').length > 0) {
    oneFiveMinTimer('.long-form__title.timer>p>em');
  }


  document.addEventListener('visibilitychange', function() {
    if (document.hidden) {
        // The tab has become inactive (hidden).
        // Execute your code here.
        console.log("Tab is now inactive.");
    } else {
        // The tab has become active (visible).
        // Execute your code here.
        console.log("Tab is now active.");
    }
});

if (String(window.location).indexOf('informative-landing') != -1){
  $(window).scroll(function() {
    // Check if the user has scrolled below 100px
    if ($(this).scrollTop() >= 100) {
        $('.informative-offer-card').css('top', '1vw');
        $('.product_stock_counter_container.small').css('top', '38vw');
    } else {
      $('.informative-offer-card').css('top', '11vw');
      $('.product_stock_counter_container.small').css('top', '207vw');
    }
  });
}


});

// Cart Upsell Popup
var cname = 'popup_value_ph'; // Cookie name

// $('.Slide_cart_checkout_button__js').click(function (e) {
// $('.cart__checkout').click(function (e) {
//   if ($('Whole_cart_popup') && getCookie(cname) == 'disabled') {
//     e.preventDefault();

//     // Initiating upsell popups
//     var statement = $('.Popup_not_visible__js').attr('data-checkout');
//     console.log(statement);
//     if (statement == '0') {
//       $('.Whole_cart_popup').css('display', 'flex');
//       setTimeout(function () {
//         $('.Whole_cart_popup').css('opacity', '1');
//       }, 200);
//     } else {
//       window.location.href = '/cart/checkout';
//     }
//   }
// });

$('.Cart_upsell_add_to_cart_btn').click(function () {
  var currentVariantId = $(this).attr('data-id');
  data = {
    "id": currentVariantId,
    "quantity": 1
  }

  jQuery.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: data,
    dataType: 'json',
    success: function () {
      window.location = '/cart/checkout';
    }
  });
});

$('.Ugc_button_a').click(function(evt){
  evt.preventDefault();
  $('html, body').animate({
      scrollTop: $("#looxReviews").offset().top
  }, 500);
  
});

$('.Cart_upsell_decline_offer_message').click(function () {
  $('.Whole_cart_popup').css('opacity', '0');
  setTimeout(function () {
    $('.Whole_cart_popup').hide();
  }, 200);
  $('.Straight_to_checkout_js').show();
  $('.Popup_trigger_js').hide();
  document.cookie = "popup_value_ph=disabled";
  window.location = '/cart/checkout';
});


$(document).on("click",".qi_cell",function() {
  $(this).toggleClass('active');
  $(this).find('.qi_cell_content').slideToggle();
});

function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

// Slick For Mobile
function handleSlick(carousel, options) {
  var width = $(window).width();
  if (width >= 800 && carousel.hasClass('slick-slider')) {
    carousel.slick('unslick');
  } else if (width < 800 && !carousel.hasClass('slick-slider')) {
    carousel.slick(options);
  }
}

// Custom-grid Percentage
var handleIntersection = function (entries, observer) {
  entries.forEach(function (entry) {
    if (entry.isIntersecting) {
      animatePercentage(entry.target);
    } else {
      resetPercentage(entry.target);
    }
  });
};
// Function to animate percentage from 0 to data-percentage value
function animatePercentage(element) {
  var percentage = $(element).data("percentage");
  var $percentageText = $(element).find("p");

  $({ countNum: 0 }).animate({ countNum: percentage }, {
    duration: 1500, // Adjust the duration as needed
    easing: "linear",
    step: function () {
      $percentageText.text(Math.floor(this.countNum) + "%");
    },
    complete: function () {
      $percentageText.text(percentage + "%");
    }
  });
}
// Function to reset the percentage to 0
function resetPercentage(element) {
  $(element).find("p").text("0%");
}


// 15min Timer
function oneFiveMinTimer(selector) {
  const timerElements = $(selector);
  const countdownDuration = 15 * 60;
  const currentTime = new Date().getTime();
  const endTime = currentTime + (countdownDuration * 1000);

  // Update the timer every second
  const timerInterval = setInterval(() => {
    const currentTime = new Date().getTime();
    const remainingTime = Math.floor((endTime - currentTime) / 1000);

    // If the countdown has ended, clear the interval
    if (remainingTime <= 0) {
      clearInterval(timerInterval);
      return;
    }

    // Format the remaining time as 'MM:SS'
    const minutes = Math.floor(remainingTime / 60).toString().padStart(2, '0');
    const seconds = (remainingTime % 60).toString().padStart(2, '0');
    const timeString = `${minutes}:${seconds}`;

    // Update each timer element with the remaining time
    timerElements.text(timeString);
  }, 1000);

  // Reset the timer when the page is refreshed
  $(window).on('beforeunload', function () {
    clearInterval(timerInterval);
  });
}